import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UtilityService } from "..";
import { ApiConfig } from "../../apiConfig";
import { GroupsData } from "../../data/selfcare/groupsData";
import { BaseResponse } from "../../models";
import { CreateGroupRequestModel, Group, UpdateGroupRequestModel, GroupsApiWrapper, GetGroupByIdRequestModel, DeleteGroupRequestModel } from "../../models/selfcare/group";

@Injectable()
export class GroupsService extends GroupsData {
    constructor(private utilityService: UtilityService) {
        super();
    }

    createGroup(request: CreateGroupRequestModel): Observable<BaseResponse<Group>> {
        return this.utilityService.postPut<Group>(
            ApiConfig.selfcare.createGroup,
            request,
            null,
            "post"
        );
    }

    getAllGroups(): Observable<BaseResponse<GroupsApiWrapper>> {
        return this.utilityService.postPut<GroupsApiWrapper>(
            ApiConfig.selfcare.getAllGroups,
            null,
            null,
            "post"
        );
    }

    getGroupById(id: number): Observable<BaseResponse<Group>> {
        // Backend expects GetGroupByIdRequestModel with GroupId property
        const request: GetGroupByIdRequestModel = { GroupId: id };
        
        return this.utilityService.postPut<Group>(
            ApiConfig.selfcare.getGroupById,
            request,
            null,
            "post"
        );
    }

    updateGroup(request: UpdateGroupRequestModel): Observable<BaseResponse<Group>> {
        return this.utilityService.postPut<Group>(
            ApiConfig.selfcare.updateGroup,
            request,
            null,
            "post"
        );
    }

    deleteGroup(id: number): Observable<BaseResponse<boolean>> {
        // Backend expects DeleteGroupRequestModel with GroupId property
        const request: DeleteGroupRequestModel = { GroupId: id };
        
        return this.utilityService.postPut<boolean>(
            ApiConfig.selfcare.deleteGroup,
            request,
            null,
            "post"
        );
    }
}
